// =============================================================================
// FILE:
// frontend/src/pms/task_execution/components/TaskExecutionFilterPanel.js
// =============================================================================

import React from "react";

import {
  Search
} from "lucide-react";


// =============================================================================
// COMPONENT
// =============================================================================

export default function TaskExecutionFilterPanel({

  filters,

  onChange,

  onApply

}) {

  return (

    <div style={styles.filterCard}>


      {/* ================================================================ */}
      {/* FILTER ROW */}
      {/* ================================================================ */}
      <div style={styles.filterRow}>


        {/* ============================================================ */}
        {/* PROJECT */}
        {/* ============================================================ */}
        <div style={styles.filterGroup}>


          <label style={styles.label}>

            Project

          </label>


          <select
            value={filters.project_id || ""}
            onChange={(e) =>

              onChange(
                "project_id",
                e.target.value
              )
            }
            style={styles.select}
          >

            <option value="">
              ALL PROJECTS
            </option>

          </select>

        </div>


        {/* ============================================================ */}
        {/* PHASE */}
        {/* ============================================================ */}
        <div style={styles.filterGroup}>


          <label style={styles.label}>

            Phase

          </label>


          <select
            value={filters.phase_id || ""}
            onChange={(e) =>

              onChange(
                "phase_id",
                e.target.value
              )
            }
            style={styles.select}
          >

            <option value="">
              ALL PHASES
            </option>

          </select>

        </div>


        {/* ============================================================ */}
        {/* STATUS */}
        {/* ============================================================ */}
        <div style={styles.filterGroup}>


          <label style={styles.label}>

            Status

          </label>


          <select
            value={filters.status || ""}
            onChange={(e) =>

              onChange(
                "status",
                e.target.value
              )
            }
            style={styles.select}
          >

            <option value="">
              ALL STATUS
            </option>

            <option value="READY">
              READY
            </option>

            <option value="WAITING">
              WAITING
            </option>

            <option value="ACTIVE">
              ACTIVE
            </option>

            <option value="BLOCKED">
              BLOCKED
            </option>

            <option value="COMPLETED">
              COMPLETED
            </option>

          </select>

        </div>


        {/* ============================================================ */}
        {/* PRIORITY */}
        {/* ============================================================ */}
        <div style={styles.filterGroup}>


          <label style={styles.label}>

            Priority

          </label>


          <select
            value={filters.priority || ""}
            onChange={(e) =>

              onChange(
                "priority",
                e.target.value
              )
            }
            style={styles.select}
          >

            <option value="">
              ALL PRIORITY
            </option>

            <option value="LOW">
              LOW
            </option>

            <option value="NORMAL">
              NORMAL
            </option>

            <option value="HIGH">
              HIGH
            </option>

            <option value="CRITICAL">
              CRITICAL
            </option>

          </select>

        </div>

      </div>


      {/* ================================================================ */}
      {/* SEARCH ROW */}
      {/* ================================================================ */}
      <div style={styles.filterRow}>


        {/* ============================================================ */}
        {/* SEARCH */}
        {/* ============================================================ */}
        <div
          style={{
            ...styles.filterGroup,
            flex: 1
          }}
        >

          <label style={styles.label}>

            Search

          </label>


          <div style={styles.searchBox}>


            <Search size={16} />


            <input
              type="text"
              placeholder={
                "Search task, phase, project..."
              }
              value={filters.search || ""}
              onChange={(e) =>

                onChange(
                  "search",
                  e.target.value
                )
              }
              style={styles.searchInput}
            />

          </div>

        </div>


        {/* ============================================================ */}
        {/* APPLY */}
        {/* ============================================================ */}
        <div style={styles.actionWrap}>


          <button
            style={styles.applyBtn}
            onClick={onApply}
          >

            Apply Filters

          </button>

        </div>

      </div>

    </div>
  );
}


// =============================================================================
// STYLES
// =============================================================================

const styles = {

  filterCard: {

    background: "#fff",

    borderRadius: 12,

    padding: 16,

    marginBottom: 20,

    boxShadow:
      "0 1px 3px rgba(0,0,0,0.08)"
  },

  filterRow: {

    display: "flex",

    gap: 16,

    flexWrap: "wrap",

    alignItems: "end",

    marginBottom: 16
  },

  filterGroup: {

    display: "flex",

    flexDirection: "column",

    minWidth: 220
  },

  label: {

    fontSize: 12,

    marginBottom: 6,

    color: "#374151",

    fontWeight: 600
  },

  select: {

    height: 40,

    borderRadius: 8,

    border: "1px solid #d1d5db",

    padding: "0 10px",

    background: "#fff"
  },

  searchBox: {

    display: "flex",

    alignItems: "center",

    gap: 8,

    border: "1px solid #d1d5db",

    borderRadius: 8,

    padding: "0 12px",

    background: "#fff",

    height: 40
  },

  searchInput: {

    border: "none",

    outline: "none",

    flex: 1,

    fontSize: 14
  },

  actionWrap: {

    display: "flex",

    alignItems: "end"
  },

  applyBtn: {

    height: 40,

    border: "none",

    background: "#2563eb",

    color: "#fff",

    borderRadius: 8,

    padding: "0 18px",

    cursor: "pointer",

    fontWeight: 600
  }
};